module.exports = __webpack_public_path__ + "static/media/flower.7de446bf.png";